import React, { useEffect, useState } from 'react';
import cn from 'classnames';

import style from './AnimateBackground.module.scss';

interface Props {
  className?: string;
  classNameOfShadow?: string;
  url?: string;
  fallBackUrl?: string;
  isContentRestricted: boolean;
}

const BACKGROUND_TIMER = 400;

function AnimateBackground({ className, classNameOfShadow, url, fallBackUrl, isContentRestricted }: Props) {
  const prevUrl = url || fallBackUrl;
  const [backgroundImageUrl, setBackgroundImageUrl] = useState(prevUrl);
  const [isBluredBackground, setIsBluredBackground] = useState(false);
  const [isAnimatingState, setIsAnimatingState] = useState(false);
  let timer: any;

  useEffect(() => {
    if (prevUrl) {
      new Promise((resolve) => {
        const img = new Image();

        img.src = prevUrl!;
        img.onload = resolve as any;
        img.onerror = resolve as any;
      });
    }
    if (prevUrl !== backgroundImageUrl) {
      setIsAnimatingState(true);

      timer = setTimeout(() => {
        setIsBluredBackground(!!fallBackUrl || isContentRestricted);
        setIsAnimatingState(false);
        setBackgroundImageUrl(prevUrl);
      }, BACKGROUND_TIMER);
    }
    return () => clearTimeout(timer);
  }, [url, fallBackUrl]);

  useEffect(() => {
    if (prevUrl === backgroundImageUrl) {
      setIsBluredBackground(!!fallBackUrl || isContentRestricted);
    }
  }, [url, isContentRestricted, fallBackUrl]);

  return (
    <>
      {isBluredBackground && <span className={style.blurImage} />}
      <div
        className={cn(className, {
          [style.animating]: isAnimatingState,
        })}
        style={{ backgroundImage: `url(${backgroundImageUrl})` }}
      >
        <span className={classNameOfShadow} />
      </div>
    </>
  );
}

export default AnimateBackground;
